import API from "api/axiosInstance";
import { setIsLoading, setListJenjang, setMessage, setStatus } from "./index";

export const fetchListJenjang =
  (page = 1, limit = 25) =>
  async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get("/jenjang/get", {
        params: { page, limit },
      });
      dispatch(setIsLoading(false));
      dispatch(
        setListJenjang({
          list: response.data.data,
          pagination: response.data.pagination,
        }),
      );
    } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddJenjang = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const formData = new FormData();
    formData.append("id_karyawan", reqData.id_karyawan);
    formData.append("kode_jabatan", reqData.kode_jabatan);
    formData.append("cabang", reqData.cabang);
    formData.append("tanggal_berlaku", reqData.tanggal_berlaku);
    formData.append("tanggal_berakhir", reqData.tanggal_berakhir);
    formData.append("tipe_jenjang", reqData.tipe_jenjang);
    formData.append("file_jenjang", reqData.file_jenjang);

    const response = await API.post("/jenjang/add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error?.response?.data?.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDeleteJenjang = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(`/jenjang/delete/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
